import { createUseStyles, multiply } from '@pushpay/styles';
import { GivingOldTheme } from '@pushpay/theming';
import { headerHeightMobile } from '../../header';
export const useStyles = createUseStyles(theme => {
  const isGivingOld = theme.colors['product-color'] === GivingOldTheme.colors['product-color'];
  const avatarSize = '32px';
  const headerHoverColor = 'rgba(255, 255, 255, 0.25)';
  const headerFocusColor = 'rgba(255, 255, 255, 0.4)';
  return {
    root: {},
    drawerMobile: {
      top: headerHeightMobile
    },
    overlayContent: {
      backgroundColor: theme.colors['color-background-surface'],
      display: 'flex',
      flexDirection: 'column',
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        height: '100%',
        maxWidth: '75vw',
        width: '280px'
      }
    },
    avatar: {
      height: avatarSize,
      width: avatarSize,
      backgroundColor: isGivingOld ? theme.colors['color-background-surface'] : theme.colors['palette-grey-dark-200'],
      color: isGivingOld ? theme.colors['palette-red'] : theme.colors['color-text-inverse']
    },
    avatarWrap: {
      height: '100%',
      padding: `${theme.SPACING.SMALL} ${theme.SPACING.SMALL} 0 0`,
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        padding: `${theme.SPACING.SMALL} 0 0`,
        fontSize: '50px',
        width: 'auto'
      }
    },
    avatarButton: {
      height: '40px',
      width: '40px',
      borderRadius: theme.SHAPE.CIRCULAR,
      justifyContent: 'center',
      '&:hover': {
        color: isGivingOld ? theme.colors['palette-white'] : theme.colors['color-text-default'],
        backgroundColor: isGivingOld ? headerHoverColor : theme.colors['palette-grey-light-300']
      },
      '&:focus': {
        outline: 'none',
        color: isGivingOld ? theme.colors['palette-white'] : theme.colors['color-text-default'],
        backgroundColor: isGivingOld ? headerFocusColor : theme.colors['palette-grey-light-300']
      }
    },
    profileSectionAvatar: {},
    profileSection: {
      height: '120px',
      display: 'flex',
      padding: `0 ${theme.SPACING.SMALL}`,
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        height: 'auto',
        flexDirection: 'column',
        alignItems: 'center',
        paddingBottom: theme.SPACING.SMALL
      }
    },
    profileInfoWrap: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      height: '100%',
      paddingTop: theme.SPACING.SMALL,
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        alignItems: 'center'
      }
    },
    profileInfoOverflowHidden: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        textAlign: 'center'
      }
    },
    fullNameText: {
      color: theme.colors['palette-black'],
      font: theme.TYPOGRAPHY.HEADLINE_3
    },
    emailText: {
      color: theme.colors['color-text-default'],
      paddingTop: multiply(theme.SPACING.GUTTER, 0.5)
    },
    profileLink: {
      alignSelf: 'flex-start',
      fontWeight: 100,
      color: isGivingOld ? theme.colors['palette-blue'] : theme.colors['product-color'],
      textDecoration: 'none',
      padding: `${theme.SPACING.GUTTER} 0`,
      '&:hover, &:focus': {
        outline: 'none',
        color: isGivingOld ? theme.colors['palette-blue'] : theme.colors['product-color'],
        textDecoration: 'underline'
      },
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        alignSelf: 'center'
      }
    },
    otherLinkSection: {
      paddingLeft: theme.SPACING.SMALL,
      borderTop: `${theme.SPACING.FIELD_BORDER_WIDTH} solid ${theme.colors['palette-grey-light-300']}`,
      [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
        padding: 0,
        display: 'flex',
        justifyContent: 'center'
      }
    },
    overlay: {
      width: '280px'
    },
    textButton: {
      fontWeight: 100,
      padding: 0,
      '&:hover, &:focus': {
        background: 'none',
        textDecoration: 'underline'
      }
    },
    loggingOut: {
      '&:hover, &:focus': {
        textDecoration: 'none'
      }
    },
    personalAccountLink: {
      display: 'flex',
      alignItems: 'center',
      height: '2.5em',
      color: isGivingOld ? theme.colors['palette-blue'] : theme.colors['product-color']
    },
    profileSwitcherIcon: {
      height: '1.25em',
      width: '1.25em',
      marginRight: '0.5em'
    },
    logOut: {}
  };
});